export const getWishListSelector = state => state.wishList.data;
export const wishListLoadingSelector = state => state.wishList.isLoading;
